// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-GlobalNav-components-Favorites-Favorites-module__favIcon__xr7Mt";
export { _1 as "favIcon" }
